import { Button, Input, Tag } from "antd";
import moment from "moment";
import React from "react";
import { Card } from "../../../utils/picketCardList/styles";
import { formatReadingScale } from "../../../../utils/readingScaleUtils";

const formatKg = (value) =>
  (value || 0).toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    useGrouping: false,
  });

// Cartão de leitura de cocho de um piquete (equivalente a uma linha da tabela).
// `form` é translation.troughFeedingAssessment.form
const PicketReadingCard = ({
  picket,
  form,
  placeholder,
  isPerSupply,
  isMissingDietDryMatter,
  scaleValues,
  onFieldChange,
}) => {
  const stay = picket.averageStayDays;
  const conf = picket.averageStayDaysConfinement;
  const history = [
    { label: "-1D", value: picket.readingResultMinus1Day },
    { label: "-2D", value: picket.readingResultMinus2Day },
    { label: "-3D", value: picket.readingResultMinus3Day },
  ];

  return (
    <Card>
      <div className="cardHeader">
        <div>
          <div className="cardTitle">{picket.picketName}</div>
          <div className="cardSubtitle">{picket.lotName}</div>
        </div>
        <div className="cardSubtitle">
          {form.amountAnimals}: <strong>{picket.amountAnimals}</strong>
        </div>
      </div>
      {picket.id && (
        <Tag
          color="orange"
          style={{ whiteSpace: "normal", height: "auto", marginBottom: 8 }}
        >
          {form.readingAlreadyDone}
        </Tag>
      )}
      {isMissingDietDryMatter && (
        <Tag
          color="red"
          style={{ whiteSpace: "normal", height: "auto", marginBottom: 8 }}
        >
          {form.dietWithoutDryMatter}
        </Tag>
      )}
      <div className="cardInfo">
        <span>
          {form.supplyDates}:{" "}
          <strong>{moment(picket.supplyDate).format("DD/MM/YYYY")}</strong>
        </span>
        {isPerSupply && (
          <span>
            {form.tableSupplyNumber}: <strong>{picket.supplyNumber}</strong>
          </span>
        )}
        <span>
          {form.realQuantitySupplied}:{" "}
          <strong>{formatKg(picket.realQuantitySupplied)}</strong>
        </span>
        <span>
          {form.supplement}: <strong>{picket.supplementName || "-"}</strong>
        </span>
        <span>
          {form.confinementTime}:{" "}
          <strong>
            {stay == null && conf == null
              ? "-"
              : `${stay ?? 0} ${form.daysUnit} (${conf ?? 0} ${
                  form.daysConfinementUnit
                })`}
          </strong>
        </span>
      </div>
      <div className="cardGrid">
        <div className="cardField fullWidth">
          <label>{form.readingResult}</label>
          <div className="historyChips">
            {history.map((entry) => (
              <Tag key={entry.label}>
                {entry.label}:{" "}
                <strong>
                  {entry.value != null ? formatReadingScale(entry.value) : "-"}
                </strong>
              </Tag>
            ))}
          </div>
          <div className="scaleButtons">
            {scaleValues.map((scale) => (
              <Button
                key={scale}
                size="large"
                type={picket.readingResult === scale ? "primary" : "default"}
                onClick={() =>
                  onFieldChange(
                    "readingResult",
                    picket.readingResult === scale ? null : scale,
                  )
                }
              >
                {formatReadingScale(scale)}
              </Button>
            ))}
          </div>
        </div>
        <div className="cardField">
          <label>{form.responsibleName}</label>
          <Input
            value={picket.responsibleName || ""}
            placeholder={placeholder}
            onChange={(e) => onFieldChange("responsibleName", e.target.value)}
          />
        </div>
        <div className="cardField">
          <label>{form.observation}</label>
          <Input
            value={picket.observation || ""}
            placeholder={placeholder}
            onChange={(e) => onFieldChange("observation", e.target.value)}
          />
        </div>
      </div>
    </Card>
  );
};

export default PicketReadingCard;
